export default "__VITE_ASSET__52c7e626__"